// import { Outlet } from "react-router-dom";
// import EmployeeSidebar from "./components/EmployeeSidebar";
// import EmployeeHeader from "./components/EmployeeHeader";
// import { Layout } from "antd";

// function EmployeeRoutes() {
//   return (
//     <div className="flex  bg-white ">
//       <EmployeeSidebar />

//       <div className="flex-grow">
//         <div
//           style={{
//             boxShadow: "41px 12px 23.2px 0px rgba(48, 183, 146, 0.12)",
//             zIndex: 10,
//             position: "relative",
//             backgroundColor: "#fff",
//           }}
//         >
//           <EmployeeHeader />
//         </div>
//         <Layout maxWidth="lg" className="flex-1">
//           <Outlet />
//         </Layout>
//       </div>
//     </div>
//   );
// }
// export default EmployeeRoutes;

import { Outlet } from "react-router-dom";
import EmployeeSidebar from "./components/EmployeeSidebar";
import EmployeeHeader from "./components/EmployeeHeader";

import Footer from "../Organization/components/Dashboard/common/Footer";
import { Layout } from "antd";
import { useState, useEffect } from "react";

function EmployeeRoutes() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Close sidebar when switching from mobile to desktop
      if (!mobile && sidebarOpen) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [sidebarOpen]);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <div className=" bg-white  relative overflow-hidden h-auto">
      {/* Sidebar */}
      <EmployeeSidebar
        isOpen={sidebarOpen}
        onClose={handleSidebarClose}
        isMobile={isMobile}
      />

      {/* Mobile Overlay */}
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={handleSidebarClose}
        />
      )}

      <div
        className={`flex flex-col flex-grow transition-all duration-300 ${
          isMobile ? "ml-0" : "ml-[258px]"
        }`}
      >
        {/* Fixed Header */}
        <div
          className="fixed top-0 right-0 left-0 z-50 bg-white shadow-sm transition-all duration-300"
          style={{
            width: isMobile ? "100%" : "calc(100% - 258px)",
            marginLeft: isMobile ? "0" : "258px",
          }}
        >
          <EmployeeHeader onMenuToggle={handleMenuToggle} isMobile={isMobile} />
        </div>

        {/* Scrollable Content Area */}
        <Layout className="flex-1 overflow-y-auto transition-all duration-300 px-2 sm:px-4 md:px-6 lg:px-8 pt-[72px] pb-[64px]">
          <div className="w-full max-w-full min-h-[calc(100vh-140px)] overflow-x-hidden">
            <Outlet />
          </div>
        </Layout>

        {/* Fixed Footer */}
        <div
          className="fixed bottom-0 right-0 left-0 z-50 bg-white shadow-sm border-t border-gray-200"
          style={{
            width: isMobile ? "100%" : "calc(100% - 258px)",
            marginLeft: isMobile ? "0" : "258px",
          }}
        >
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default EmployeeRoutes;
